import { defineComponent, h } from 'vue';

export default defineComponent({
  name: 'router-fake-component',
  render() {
    return h('span');
  },
});
